import { createContext, useContext, useState } from 'react'
import styles from '../components/layout/styles/toast.css'

const ToastContext = createContext()
export default function ToastProvider({children}){
    const [toast,setToast] = useState({visivel: false, mensagem: '', tipo: ''})

    const mostrarAviso = ( mensagem, tipo = 'sucesso')=>{
        setToast({visivel: true, mensagem,tipo})

        setTimeout(()=>{
            setToast({visivel: false, mensagem: '', tipo:''})
        },3500)
    } 
    return(
        <ToastContext.Provider value={{mostrarAviso}}>
            {children}
            {toast.visivel && (
                <div className={`toast-flutuante toast-${toast.tipo}`}>
                    {toast.mensagem}
                </div>
            )}
        </ToastContext.Provider>
    )
}
export const useToast = ()=> useContext(ToastContext)